// src/pages/TermsAndConditions.js
import React, { useEffect } from "react";
import styled from "styled-components";

// Styled-components for the page
const Container = styled.div`
  padding: 30px 50px;
  line-height: 1.6;
  color: rgb(119, 119, 119);
  @media (min-width: 1200px) {
    padding: 30px 100px;
  }
  @media (max-width: 768px) {
    padding: 30px 25px;
    ul {
      margin-left: unset;
      padding-left: 1.3rem;
    }
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: 26px !important;
  margin-bottom: 20px;
  @media (min-width: 1200px) {
    font-size: 30px !important;
  }
`;

const SubTitle = styled.h2`
  font-size: 18px !important;
  margin-top: 20px;
  font-weight:bold;
`;

const Paragraph = styled.p`
  font-size: 16px !important;
  margin-bottom: 15px;
  text-align: left;
`;
const CopyRight = styled.p`
  font-size: 14px !important;
  text-align: center;
`;

const List = styled.ul`
  margin-left: 20px;
  list-style-type: disc;
`;

const ListItem = styled.li`
  margin-bottom: 10px;
`;

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container>
      <Title>RIZE TERMS AND CONDITIONS</Title>
      <Paragraph>
        Welcome to Rize mobile application! These Terms and Conditions
        (hereinafter, the “T&Cs”) constitute a legally binding agreement between
        you and us, governing your access to and use of the Rize application
        (hereinafter, the “App”), as well as the products or services made
        available in or through it (hereinafter, the “Services”). Please read
        these T&Cs carefully before accessing or using the App or Services to
        understand your rights and responsibilities. If you have any questions
        about these T&Cs, please contact us or consult your lawyer to address
        any concerns before accessing or using the App or Services.
      </Paragraph>

      <SubTitle>1. ACCEPTANCE OF T&Cs</SubTitle>
      <Paragraph>
        By accessing or using the App or any Service, you acknowledge that you
        have read, understood, and agreed to be bound by these T&Cs. You also
        confirm that you meet the minimum age and possess the legal capacity
        required under your local laws to enter into similar agreements, or that
        your legal guardian consents to your use of the App and Services under
        these T&Cs.
      </Paragraph>
      <Paragraph>
        If you are accessing or using the App or Services on behalf of a
        business or entity, you represent and warrant that you have the
        authority to bind that business or entity to these T&Cs. If you do not
        agree to all the T&Cs, you must not access or use the App or Services.
      </Paragraph>

      <SubTitle>2. KEY DEFINITIONS</SubTitle>
      <List>
        <ListItem>
          <h6>“Arab Bank”</h6> means the Arab Bank - Egypt.
        </ListItem>
        <ListItem>
          <h6>“Content”</h6> means any software, text, graphics, logos, and
          trademarks or other materials uploaded, downloaded, or appearing on or
          through the App or Services.
        </ListItem>
        <ListItem>
          <h6>“CBE”</h6> means the Central Bank of Egypt.
        </ListItem>
        <ListItem>
          <h6>“Intellectual Property Rights”</h6> means all rights associated
          with the protection of creations of the mind, as applicable under any
          local, foreign, or international law. These rights include, but are
          not limited to, copyrights, trademarks, patents, trade secrets, and
          any other proprietary rights.
        </ListItem>
        <ListItem>
          <h6>“Licensed Materials”</h6> means the App, including its Services,
          Content, and functionalities, as made available, amended, or modified
          from time to time at our sole and absolute discretion.
        </ListItem>
        <ListItem>
          <h6>“Meeza”</h6> means the payment network operated by the Egyptian
          Banks Company (EBC).
        </ListItem>
        <ListItem>
          <h6>“Privacy Policy”</h6> means Rize Privacy Policy published on the
          App, as amended from time to time.
        </ListItem>
        <ListItem>
          <h6>“Personal Data”</h6> means any data relating to an identified or
          identifiable natural person, including but not limited to names,
          contact information, identification numbers, financial data, online
          identifiers, or any data that could identify an individual.
        </ListItem>
        <ListItem>
          <h6>“Rize Card”</h6> means the Rize prepaid card, issued by the Arab
          Bank and powered by Visa.
        </ListItem>
        <ListItem>
          <h6>“Rize Account”</h6> means an account a User creates on the App,
          which is linked to such User’s activated Rize Card.
        </ListItem>
        <ListItem>
          <h6>“Rize Card Services”</h6> means all the Services and features
          related to Rize Card, as described in Clause 6 of these T&Cs.
        </ListItem>
        <ListItem>
          <h6>“Scheme”</h6> means the payment network that sets the rules and
          standards for card-based payments and ensures that these payments are
          processed safely and efficiently, connecting merchants, banks, and
          payment processors. Rize Card is powered by Visa and supported by
          other networks such as Meeza and Mastercard.
        </ListItem>
        <ListItem>
          <h6>“Third-Party Provider”</h6> refers to any individual or entity
          other than us, that offers Third-Party Services. These providers
          operate independently and are responsible for their own policies,
          practices, and terms of service.
        </ListItem>
        <ListItem>
          <h6>“Third-Party Services”</h6> means any products, services,
          features, links, content, data, or other materials that are made
          accessible to you by Third-Party Providers through or in connection
          with the App.
        </ListItem>
        <ListItem>
          <h6>“Third-Party T&Cs”</h6> means the terms and conditions set by
          Third-Party Providers for accessing and using their Third-Party
          Services.
        </ListItem>
        <ListItem>
          <h6>“User”</h6> means any person or entity who accesses or uses the
          App or Services.
        </ListItem>
        <ListItem>
          <h6>“User Content”</h6> means any content you submit, post, or upload
          in connection with your use of the App or Services.
        </ListItem>
        <ListItem>
          <h6>“Visa”</h6> means Visa Inc.
        </ListItem>
        <ListItem>
          <h6>“we” or “us”</h6> means e-Novate for Operation and Management of
          Digital Payment Smart Solutions S.A.E., a corporation specializing in
          technology and digital payment, incorporated and operating under
          Egyptian law.
        </ListItem>
      </List>

      <SubTitle>3. ELIGIBILITY REQUIREMENTS</SubTitle>
      <Paragraph>
        By registering for and using the App and Rize Card Services, you confirm
        that you meet the following requirements (collectively, the “Eligibility
        Requirements”):
      </Paragraph>
      <List>
        <ListItem>
          <h6>(a) Eligible Users.</h6> You must be an Egyptian national with at
          least 16 years old. You must obtain a Rize Card from your university
          and successfully register for a Rize Account through the App.
        </ListItem>
        <ListItem>
          <h6>(b) Prohibited Users.</h6> Rize Card Services are not meant for
          individuals or entities that are: (i) subject to any government-issued
          sanctions or prohibited persons lists, or (ii) using the services for
          unlawful purposes or prohibited activities, including fraud, money
          laundering, or other illicit behavior.
        </ListItem>
        <ListItem>
          <h6>(c) Technical Requirements.</h6> To install and use the App, you
          must have a compatible device and operating system. Updates to the App
          or its Services may require newer versions of software or hardware,
          which you are responsible for providing.
        </ListItem>
      </List>
      <Paragraph>
        Failure to comply with one or more of the above Eligibility Requirements
        may result in the suspension or termination of your Rize Account.
      </Paragraph>

      <SubTitle>4. REGISTRATION FOR RIZE ACCOUNT</SubTitle>
      <Paragraph>
        To access and use the Rize App and its Services, you must create a Rize
        Account by following the guided steps displayed on the interface. You
        are required to provide accurate, complete, and up-to-date information
        during the registration process. It is your responsibility to maintain
        the accuracy of your account information and promptly update it if any
        changes occur. You are permitted to create and maintain only one Rize
        Account. You acknowledge that your account may be terminated or
        suspended if you provide false, incomplete, or misleading information,
        or if you register for duplicate accounts.
      </Paragraph>

      <SubTitle>5. LICENSE TO USE</SubTitle>
      <Paragraph>
        Subject to your full compliance with these T&Cs, the successful
        registration for a Rize Account, and, as applicable, the Rize Card
        activation, we grant you a limited, non-exclusive, non-transferable, and
        revocable right to access and use the Licensed Materials for your
        personal, non-commercial purposes. You agree that our Licensed Materials
        may be amended, changed, or discontinued at any time based on our sole
        and absolute discretion.
      </Paragraph>

      <SubTitle>6. RIZE CARD SERVICES</SubTitle>
      <Paragraph>
        We provide a comprehensive digital platform designed to enhance your
        financial experience by offering a suite of services and features
        related to your Rize Card. Rize Card Services are as follows:
      </Paragraph>

      <SubTitle>(a) Rize Card Activation</SubTitle>
      <Paragraph>
        Once you have received your Rize Card from your university and your
        application has been validated by the Arab Bank, you can activate your
        Rize Card seamlessly through the App. To complete the activation
        process, simply follow the guided steps displayed on the interface and
        ensure that you provide the required information fully and accurately.
        As part of the activation process, you may be required to verify your
        identity by providing government-issued identification or other
        documents. We handle and share your information in accordance with our
        Privacy Policy, as necessary to validate your identity and ensure the
        secure activation of your Rize Card, in compliance with applicable laws,
        regulations, and CBE requirements.
      </Paragraph>

      <SubTitle>(b) Balance Top-Up</SubTitle>
      <Paragraph>
        You can add funds to your Rize Account through the following methods:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Bank Cards.</h6> Link a supported Bank card to the App and
          transfer funds to your Rize Account.
        </ListItem>
        <ListItem>
          <h6>Instant Payment Network (IPN):</h6> Top up your Rize Account
          quickly through apps supporting IPN transfers, such as Instapay.
        </ListItem>
        <ListItem>
          <h6>Peer-to-Peer (P2P) Transfers:</h6> Receive funds transferred to
          you from another Rize Account via the App.
        </ListItem>
        <ListItem>
          <h6>Point-of-Sale (POS) Terminals:</h6> Deposit funds using supported
          POS terminals.
        </ListItem>
        <ListItem>
          <h6>ATMs:</h6> Add funds through ATMs that support Rize Card.
        </ListItem>
      </List>
      <Paragraph>
        The availability of these methods may vary depending on your location,
        service providers, and applicable regulations. Additional fees or limits
        may apply based on the top-up method used, as determined by the service
        provider.
      </Paragraph>

      <SubTitle>(c) Payment</SubTitle>
      <Paragraph>
        You can use your Rize Card to make electronic payments for goods and
        services under the following terms:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Payment Methods.</h6> The Rize Card can be used to make payments
          to merchants within the Scheme. Payments can be processed through
          various channels, including POS terminals and payment gateways.
        </ListItem>
        <ListItem>
          <h6>Payment Authorization.</h6> Transactions made using the Rize Card
          may require your authorization via a PIN, OTP, biometric verification,
          or other secure methods.
        </ListItem>
        <ListItem>
          <h6>Fund Sufficiency.</h6> It is your responsibility to ensure that
          sufficient funds are available in your Rize Account to complete any
          payment transaction.
        </ListItem>
        <ListItem>
          <h6>Transaction Limits.</h6> Payments may be subject to limits on a
          daily, monthly, or per-transaction basis, as determined by the CBE.
          Any attempt to exceed these limits may result in a declined
          transaction.
        </ListItem>
        <ListItem>
          <h6>Processing Time.</h6> Payments are typically processed instantly.
          However, delays may occur due to technical issues, merchant systems,
          compliance checks, or other factors beyond our control.
        </ListItem>
        <ListItem>
          <h6>Merchant Responsibility.</h6> We are not responsible for the
          quality, safety, legality, or delivery of goods or services purchased
          using the Rize Card or the App. Any issues related to goods or
          services must be resolved directly with the merchant.
        </ListItem>
        <ListItem>
          <h6>Fees.</h6> Payments made using the Rize Card will be free of
          charge.
        </ListItem>
      </List>
      <SubTitle>(d) Fund Transfer</SubTitle>
      <Paragraph>
        Through the App, you can transfer funds from your Rize Account to
        another Rize Account under the following terms:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Eligibility:</h6> Both the sender and the recipient must have an
          active and verified Rize Card and Rize Account to initiate or receive
          a transfer.
        </ListItem>
        <ListItem>
          <h6>Process:</h6> To send funds, follow the steps displayed in the App
          interface, including selecting the recipient, entering the transfer
          amount, and confirming the transaction. Once a transfer has been
          completed, it cannot be reversed or canceled. You are solely
          responsible for verifying the details of the transfer before
          submission.
        </ListItem>
        <ListItem>
          <h6>Limits:</h6> Transfers may be subject to daily, monthly, or
          per-transaction limits, as determined by the CBE.
        </ListItem>
        <ListItem>
          <h6>Processing Time:</h6> Transfers are typically processed instantly.
          However, delays may occur due to technical issues, compliance checks,
          or other factors beyond our control.
        </ListItem>
        <ListItem>
          <h6>Fees:</h6> Fund transfers between Rize Cards are generally free,
          but charges may apply in certain cases. Any applicable fees will be
          disclosed before the transaction is completed.
        </ListItem>
        <ListItem>
          <h6>Liability for Transfers:</h6> We are not responsible for any loss
          resulting from your failure to provide accurate recipient details or
          comply with applicable terms.
        </ListItem>
      </List>

      <SubTitle>(e) Fund Withdrawal</SubTitle>
      <Paragraph>
        You can withdraw funds from your Rize Account using your Rize Card
        through ATMs that support Rize cards under the following terms:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Transaction Authorization:</h6> Withdrawals require your
          authorization through a PIN or other secure methods. You are
          responsible for safeguarding your PIN and other credentials to prevent
          unauthorized transactions.
        </ListItem>
        <ListItem>
          <h6>Withdrawal Limits:</h6> Withdrawals are subject to daily, monthly,
          or per-transaction limits, as determined by the CBE. These limits may
          be communicated to you, upon request, via the App or through customer
          support.
        </ListItem>
        <ListItem>
          <h6>Processing Time:</h6> ATM withdrawals are typically processed
          instantly. However, delays or issues may occur due to technical issues
          (e.g., ATM malfunctions, bank systems), compliance checks, or other
          factors beyond our control.
        </ListItem>
        <ListItem>
          <h6>Liability for Insufficient Funds:</h6> It is your responsibility
          to ensure sufficient funds are available in your Rize Account to cover
          the withdrawal amount and any associated fees. Transactions exceeding
          your Rize Account balance will be declined.
        </ListItem>
        <ListItem>
          <h6>ATM Availability:</h6> The availability of ATMs may vary based on
          your location and network coverage. We are not liable for
          interruptions or unavailability of ATM services.
        </ListItem>
        <ListItem>
          <h6>Fees:</h6> ATM withdrawals may incur fees, including operator fees
          and Scheme fees. Any applicable fees are determined by the relevant
          bank or Scheme without our interference.
        </ListItem>
      </List>

      <SubTitle>(f) Chargeback Disputes</SubTitle>
      <Paragraph>
        You may request a chargeback (refund) for payment transactions and fund
        withdrawals made by your Rize Card (a “Chargeback”) under the following
        terms:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Eligibility:</h6> Chargebacks for payment transactions can be
          requested if: (i) goods or services were not received, (ii) goods or
          services received were defective, damaged, or not as described, (iii)
          unauthorized transactions occurred (e.g., fraud), (iv) a duplicate
          charge was made, (v) a billing error occurred. Chargebacks for fund
          withdrawals can be requested if: (i) the ATM did not dispense the
          requested funds while the funds were deducted from your Rize Account,
          (ii) the ATM dispensed an amount not equal to the amount deducted from
          your Rize Account, or (iii) the ATM processed a duplicate transaction.
        </ListItem>
        <ListItem>
          <h6>Request Submission:</h6> To submit a Chargeback request, you must:
          (i) provide the required transaction details, including the date,
          amount, and merchant/bank name, (ii) explain the reason for the
          requested chargeback and include any supporting documentation (e.g.,
          receipts, correspondence with the merchant), and (iii) submit your
          request through the designated process outlined in the App or by
          contacting our customer support.
        </ListItem>
        <ListItem>
          <h6>Timeframe:</h6> You must submit your Chargeback request within 30
          days from the date of the relevant transaction or withdrawal. Failing
          to meet this deadline may result in your chargeback request being
          denied.
        </ListItem>
        <ListItem>
          <h6>Chargeback Processing:</h6> Once your Chargeback request is
          submitted, we will review it for eligibility and completeness. If
          required, we may request additional information or documentation. The
          Chargeback process may take several weeks to resolve, as it involves
          communication between us, the merchant’s bank, and the applicable
          Scheme.
        </ListItem>
        <ListItem>
          <h6>Denial of Chargebacks:</h6> Chargebacks may be denied if: (i) the
          timeframe for submitting the Chargeback request has passed, (ii) the
          claim falls outside the eligibility criteria mentioned in this Clause,
          (iii) insufficient or inaccurate information is provided, (iv) the
          applicable Scheme determines that you are not eligible for the
          requested Chargeback.
        </ListItem>
        <ListItem>
          <h6>Non-Liability for Denied Requests:</h6> You understand and
          acknowledge that we are merely acting as an intermediary between you
          and the Chargeback stakeholders. We do not issue any decisions
          regarding Chargeback requests and, therefore, we are not liable for
          any losses resulting from denied Chargebacks.
        </ListItem>
        <ListItem>
          <h6>Governing Rules:</h6> Chargebacks are mainly governed by the
          dispute resolution rules of the applicable Scheme and applicable laws
          (collectively, the “Chargeback Rules”). The Chargeback Rules are
          incorporated into these T&Cs by this reference and will always
          supersede in case of discrepancy.
        </ListItem>
      </List>
      <SubTitle>(g) Balance Inquiry</SubTitle>
      <Paragraph>
        You can check your Rize Card balance at any time through the App. The
        balance information displayed will reflect the most recent data
        available but may be subject to delays or inaccuracies due to network
        issues, system updates, pending transactions, or synchronization with
        the Arab Bank’s servers.
      </Paragraph>

      <SubTitle>(h) Transaction Tracking</SubTitle>
      <Paragraph>
        The App enables you to track and review a log of transactions made using
        your Rize Card up to a limited time. The transaction history is
        displayed in chronological order and may include details such as the
        merchant’s name, transaction amount, and date. While we strive to ensure
        accurate and up-to-date information, discrepancies may arise due to
        processing times or system errors.
      </Paragraph>
      <SubTitle>7. THIRD-PARTY SERVICES</SubTitle>
      <Paragraph>
        7.1 The App may include or link to Third-Party Services. These
        Third-Party Services are provided for your convenience and are not under
        our control. We do not endorse, monitor, or have any responsibility for
        the content, policies, practices, or availability of any Third-Party
        Services.
      </Paragraph>
      <Paragraph>
        7.2 When you access or use Third-Party Services, you agree that: (i) you
        access and use such services at your own risk; (ii) the terms,
        conditions, and policies of the respective Third-Party Providers will
        govern your access and use of such services; (iii) any interactions,
        transactions, or disputes arising from or related to your use of
        Third-Party Services are solely between you and the relevant Third-Party
        Provider, without any responsibility or liability on our part.
      </Paragraph>
      <Paragraph>
        7.3 We encourage you to review the applicable terms, conditions, and
        policies of any Third-Party Services before accessing or using them. If
        you have concerns regarding the compatibility, appropriateness, or
        security of any Third-Party Services, we recommend that you discontinue
        use immediately and contact us for any assistance we can provide.
      </Paragraph>

      <SubTitle>8. INTELLECTUAL PROPERTY RIGHTS</SubTitle>
      <Paragraph>
        You understand and acknowledge that all Intellectual Property Rights in
        the Licensed Materials are owned by us or by our Third-Party Providers.
        You acknowledge that no title to these rights is transferred to you, and
        you agree not to use the Licensed Materials in any way that infringes
        these rights. Unless you have our written permission, you may not copy,
        modify, distribute, sell, license, or create derivative works from the
        Licensed Materials. You may not reverse engineer, decompile,
        disassemble, crack, or attempt in any manner to extract the source code
        of the Licensed Materials. Additionally, you may not register, attempt
        to register, or assert any rights in Licensed Materials unless these
        rights are explicitly granted to you by our written consent. You agree
        that any enhancements, updates, upgrades, modifications, or derivative
        works created from, generated by, or derived in any way from our
        Licensed Materials by us or you, or otherwise as a result of your use of
        the Licensed Materials, will be our exclusive property.
      </Paragraph>

      <SubTitle>9. USER CONTENT</SubTitle>
      <Paragraph>
        You are fully responsible for your User Content. By submitting User
        Content to or through the App or Services, you grant us and our
        Third-Party Providers a worldwide, non-exclusive, royalty-free right to
        use, copy, modify, share, and display such content as needed for
        operating the App and Services. You undertake that your User Content
        will not infringe third-party rights or contain illegal or offensive
        material. We reserve the right to remove any User Content that violates
        these T&Cs, any applicable laws, or that we deem objectionable.
      </Paragraph>

      <SubTitle>10. SECURITY</SubTitle>
      <Paragraph>
        10.1 We are committed to safeguarding your data that is within our
        systems and under our control, in accordance with the security standards
        mandated by CBE. However, you understand and acknowledge that a
        significant share of the security of the Rize App and Services is a
        shared responsibility, relying on multiple stakeholders beyond us. These
        stakeholders include you, Arab Bank, Third-Party Providers, and other
        entities involved in the Services (e.g., banks, payment processors, and
        schemes). Below, we define our security responsibilities, as well as
        those of other stakeholders, including you.
      </Paragraph>
      <Paragraph>
        10.2 Our Responsibilities. We take the following measures to ensure the
        security of your information and transactions:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Data Encryption:</h6> We employ appropriate cryptographic
          protocols to protect your data when it is within our systems and under
          our control, specifically:
          <List>
            <ListItem>
              <h6>In-App Transactions and Communications:</h6> Data exchanged
              between the Rize App and our servers (e.g., login credentials,
              account details, and card management requests) is protected during
              transmission to prevent unauthorized access.
            </ListItem>
            <ListItem>
              <h6>Stored Data:</h6> Any Personal Data or transaction data stored
              within our systems is protected from unauthorized access.
            </ListItem>
            <ListItem>
              <h6>Integration with Third Parties:</h6> We use secure and
              encrypted channels to share your data with Third-Party Providers
              and other entities (collectively “Third Parties”) as necessary to
              enable the Services. These Third Parties include, but are not
              limited to, the Arab Bank, Schemes, payment processors, and
              sellers of digital products.
            </ListItem>
          </List>
        </ListItem>
        <ListItem>
          <h6>Payment Authorization:</h6> We utilize secure methods such as
          personal identification numbers (PINs) and one-time passwords (OTPs)
          to authenticate transactions and prevent unauthorized access.
        </ListItem>
        <ListItem>
          <h6>Fraud Monitoring:</h6> Transactions, including payments and
          withdrawals, are monitored to identify and address potential fraud or
          unauthorized activities. Suspicious transactions may be delayed,
          declined, or require additional verification.
        </ListItem>
        <ListItem>
          <h6>Data Retention and Deletion:</h6> Your data is stored and retained
          in accordance with our Privacy Policy and the Egyptian laws and
          regulations.
        </ListItem>
      </List>
      <SubTitle>10.3 Your Responsibilities</SubTitle>
      <Paragraph>
        You have a crucial part to play in maintaining the security of your Rize
        Card and Rize Account. To protect yourself:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Account Credentials:</h6> Do not share your login credentials
          (e.g., username, password, PIN, or OTPs) with anyone whatsoever. Any
          activity conducted using your credentials will be deemed authorized by
          you.
        </ListItem>
        <ListItem>
          <h6>Devices and Networks:</h6> Access the App only from trusted
          devices and networks. Keep your device operating system and the App
          updated to the latest version to minimize vulnerabilities and avoid
          using public or unsecure networks to reduce security risks. Take
          proactive measures to secure your device and network, such as enabling
          device encryption, using h6 and unique passwords, enabling
          multi-factor authentication (MFA) where applicable, and installing
          trusted antivirus or security software.
        </ListItem>
        <ListItem>
          <h6>Unauthorized Access:</h6> If you suspect unauthorized access or
          notice unusual activity, change your Rize Account password immediately
          and contact us through the App or our support team. Prompt reporting
          helps us take swift action to protect your Rize Account.
        </ListItem>
      </List>

      <SubTitle>10.4 Third Parties' Responsibilities</SubTitle>
      <Paragraph>
        Once your data is transmitted to a Third Party, data security and
        encryption are governed by the Third Party’s respective systems and
        policies. While we work closely with these Third Parties to enhance
        security, we are not liable for any failures attributable to their
        practices. The security responsibilities of Third Parties generally
        include the following:
      </Paragraph>
      <List>
        <ListItem>
          <h6>ATM Banks and Payment Processors:</h6> These entities are
          responsible for ensuring the secure operation of their systems when
          processing your transactions.
        </ListItem>
        <ListItem>
          <h6>Schemes:</h6> These entities manage the card network
          infrastructure and are responsible for ensuring that transactions are
          securely processed within their systems.
        </ListItem>
        <ListItem>
          <h6>Third-Party Providers:</h6> Third-Party Providers are responsible
          for the security of their Third-Party Services.
        </ListItem>
      </List>

      <SubTitle>11. PERSONAL DATA PROTECTION</SubTitle>
      <Paragraph>
        By accessing and using the App and Services, you consent to the
        processing of your Personal Data in accordance with these T&Cs and our
        Privacy Policy, which may be updated from time to time. It is your
        responsibility to review the T&Cs and Privacy Policy periodically to
        stay informed about how your Personal Data is collected, used, shared,
        and protected.
      </Paragraph>

      <SubTitle>12. COMPLIANCE AND MONITORING</SubTitle>
      <Paragraph>
        By using the App and its Services, you agree to comply with all
        applicable laws, regulations, and guidelines, including but not limited
        to those of the Arab Republic of Egypt. Without limiting the foregoing,
        you specifically acknowledge and agree to the following:
      </Paragraph>
      <List>
        <ListItem>
          <h6>Applicable Laws:</h6> The App operates in accordance with the
          legal and regulatory framework of the Central Bank of Egypt (CBE), the
          Egyptian Anti-Money Laundering (AML) Law, the Cybercrime Law, and any
          other relevant legislation.
        </ListItem>
        <ListItem>
          <h6>Know Your Customer (KYC) Requirements:</h6> As required by law, we
          and Arab Bank may collect, verify, store, and share your Personal Data
          and financial information as necessary for establishing, activating,
          and maintaining your Rize Account and Rize Card. This includes, but is
          not limited to, identity verification to prevent fraud, money
          laundering, and other illicit activities.
        </ListItem>
        <ListItem>
          <h6>
            Anti-Money Laundering (AML) and Counter-Terrorism Financing (CTF):
          </h6>{" "}
          All transactions processed through your Rize Card are subject to
          monitoring for compliance with AML and CTF regulations. We reserve the
          right to review, delay, or reject any transaction deemed suspicious or
          non-compliant.
        </ListItem>
        <ListItem>
          <h6>Sanctions Compliance:</h6> You must not use the App to engage in
          activities or transactions that violate local or international
          sanctions. This includes refraining from transacting with entities or
          individuals subject to sanctions imposed by Egyptian authorities or
          other recognized bodies.
        </ListItem>
        <ListItem>
          <h6>User Responsibilities:</h6> You are solely responsible for
          ensuring that your use of the App and Services, including payment
          transactions, fund transfers, and other transactions, complies with
          applicable laws and regulations. Any violation may result in account
          suspension, termination, or legal action.
        </ListItem>
        <ListItem>
          <h6>Reporting Obligations:</h6> We are legally obligated to report
          suspicious activities or transactions to relevant authorities,
          including the Egyptian Money Laundering and Terrorist Financing
          Combating Unit (EMLCU), without notifying you.
        </ListItem>
      </List>
      <SubTitle>13. WARRANTIES</SubTitle>
      <Paragraph>
        You understand and agree that you use the App and Services at your own
        risk. To the fullest extent permitted by law, we provide the App and
        Services on an "as is" and "as available" basis, without any warranties
        or representations of any kind. This means we make no promises regarding
        their quality, suitability for a specific purpose, ownership rights, or
        protection from third-party claims. Additionally, we do not guarantee
        that:
      </Paragraph>
      <List>
        <ListItem>
          The App or Services will always be available, secure, timely, or
          error-free;
        </ListItem>
        <ListItem>Any issues or errors will be fixed;</ListItem>
        <ListItem>
          The App or Services will meet your specific needs or expectations.
        </ListItem>
      </List>

      <SubTitle>14. LIABILITY</SubTitle>
      <Paragraph>
        <h6>14.1 Your Liability:</h6> To the maximum extent permitted by
        applicable law, you agree to indemnify us for any and all claims,
        damages, liabilities, penalties, costs, and expenses, including
        reasonable attorney’s fees and costs of litigation (collectively,
        “Claims”) that are brought against or incurred by us as a result of your
        breach of these T&Cs or any Third-Party T&Cs, including without
        limitation:
      </Paragraph>
      <List>
        <ListItem>
          Your misuse of the App, Rize Card, or associated Services;
        </ListItem>
        <ListItem>
          Your violation of any applicable laws or regulations;
        </ListItem>
        <ListItem>
          Any fraudulent, negligent, or unlawful activity conducted using your
          Rize Account.
        </ListItem>
      </List>
      <Paragraph>
        We reserve the right to assume exclusive defense and control of any
        matter subject to indemnification by you, at your expense, and you agree
        to cooperate fully with us in asserting any available defenses.
      </Paragraph>

      <Paragraph>
        <h6> 14.2 Our Liability</h6>
      </Paragraph>
      <h6>14.2.1 General Disclaimer</h6>
      <Paragraph>
        To the fullest extent permitted by law, you acknowledge and agree that
        neither we nor our affiliates, officers, directors, employees or agents,
        will be liable for any direct or indirect damages arising out of or in
        connection with your access to, use of, or inability to access or use
        the App or Services (including Third-Party Services), even if we are
        aware of the possibility of such damages. Without limiting the
        foregoing, this disclaimer specifically includes, without limitation,
        any direct or indirect damages arising from our negligence (including
        gross negligence) or misconduct, as well as those arising from any
        negligence, fraud, or misconduct (whether material or immaterial)
        committed by our Third-Party Providers.
      </Paragraph>

      <h6>14.2.2 Limitation of Liability</h6>
      <Paragraph>
        Without prejudice to the above general disclaimer, you agree that our
        maximum aggregate liability arising out of or in connection with your
        access to or use of, or inability to access or use, the App or Services
        will be limited to the amount of fees you paid for the respective
        Service.
      </Paragraph>

      <h6>14.2.3 Non-excluded Liability</h6>
      <Paragraph>
        You understand that certain liabilities may be required by law and
        cannot be waived or limited by any agreement. All disclaimers and
        liability limitations in this clause (14) will apply only as far as the
        law allows, and nothing here is intended to limit or misrepresent your
        legal rights under applicable laws.
      </Paragraph>

      <SubTitle>15. TERMINATION AND SUSPENSION OF RIZE ACCOUNT</SubTitle>
      <Paragraph>
         <h6>15.1 Termination or Suspension by You:</h6> You may terminate or
        suspend your Rize Account at any time by ceasing use of the Services and
        contacting our support team. Before terminating your Rize Account, you
        must withdraw all funds from the account, but you do not need to do the
        same in case of suspension.
      </Paragraph>
      <Paragraph>
        <h6>15.2 Termination or Suspension by Us:</h6> We reserve the absolute
        right to suspend or terminate your Rize Account, or discontinue the App
        and Services in whole, at any time, with or without prior notice, if we
        believe that:
      </Paragraph>
      <List>
        <ListItem>
          You are in actual or suspected breach of these T&Cs or any Third-Party
          T&Cs;
        </ListItem>
        <ListItem>
          It is no longer feasible for our business to continue providing the
          App and Services.
        </ListItem>
      </List>
      <Paragraph>
        Any such termination will not affect your right to a refund of your Rize
        Account funds within the legal timeframe, subject to any deductions we
        are legally entitled to make.
      </Paragraph>

      <Paragraph>
        <h6>15.3 Effects of Termination:</h6> In the event of termination, for
        any reason:
      </Paragraph>
      <List>
        <ListItem>
          All rights granted to you with respect to the App and Services will
          immediately cease;
        </ListItem>
        <ListItem>
          All your data and transaction records will be permanently deleted from
          our servers, unless retention is required by law or regulatory
          authorities.
        </ListItem>
      </List>

      <SubTitle>16. GOVERNING LAW AND DISPUTE RESOLUTION</SubTitle>
      <Paragraph>
        These T&Cs are governed by and construed in accordance with the laws of
        Egypt, without regard to its conflict of law provisions. Any disputes
        arising out of or relating to these T&Cs shall be resolved exclusively
        by the courts of Egypt.
      </Paragraph>

      <SubTitle>17. GENERAL PROVISIONS</SubTitle>
      <Paragraph>
        <h6>17.1 Assignment:</h6> You may not transfer or assign any of your
        rights or obligations under these T&Cs to any third party, except as
        explicitly authorized by us in writing.
      </Paragraph>
      <Paragraph>
        <h6>17.2 Waiver:</h6> Our failure or delay in exercising or enforcing
        any of our rights or remedies under these T&Cs shall not constitute a
        waiver of such rights or remedies or any other rights or remedies. Any
        waiver of rights or remedies by us will not extend to other rights or
        remedies. No single or partial exercise of our rights or remedies under
        these T&Cs will preclude any further exercise of those rights or
        remedies, or the exercise of any other rights or remedies.
      </Paragraph>
      <Paragraph>
        <h6>17.3 Set-off:</h6> We reserve the right to automatically deduct any
        amounts owed to us or our Third-Party Providers for your use of the App
        or Services without obtaining your consent. Upon request, we will notify
        you of such deductions through the App or our customer support.
      </Paragraph>
      <Paragraph>
        <h6>17.4 Severability:</h6> If any clause or provision of these T&Cs is
        found by a court of competent jurisdiction to be invalid, unenforceable,
        or illegal, such a finding shall not affect the validity or
        enforceability of the remaining clauses or provisions. Such invalid,
        unenforceable, or illegal clause or provision will apply to the maximum
        extent permitted by law.
      </Paragraph>
      <Paragraph>
        <h6>17.5 Entire Agreement:</h6> These T&Cs constitute the entire
        agreement between the Parties regarding their scope and supersede all
        other agreements, documents, or statements, whether written or oral,
        concerning the same subject matter. However, the terms of the Arab Bank
        form that you signed for obtaining your Rize Card from your university
        will be considered an integral part of these T&Cs and will apply as if
        they were included here.
      </Paragraph>
      <Paragraph>
        <h6> 17.6 T&C Updates:</h6> We reserve the right to amend, modify, or
        entirely replace these T&Cs at our sole discretion (each, a “T&C
        Update”). While we will make reasonable efforts to notify you of T&C
        Updates via App notifications, you are responsible for periodically
        reviewing the T&Cs. Your continued access to or use of the App or
        Services following any T&C Update constitutes your acceptance of the
        updated T&Cs.
      </Paragraph>
      <Paragraph>
        <h6>17.7 Surviving Clauses:</h6> The following clauses will continue to
        apply after your account is terminated for any reason:
      </Paragraph>
      <List>
        <ListItem>Clause 8 (Intellectual Property Rights)</ListItem>
        <ListItem>Clause 9 (User Content)</ListItem>
        <ListItem>Clause 11 (Personal Data Protection)</ListItem>
        <ListItem>Clause 12 (Compliance and Monitoring)</ListItem>
        <ListItem>Clause 14 (Liability)</ListItem>
        <ListItem>Clause 16 (Governing Law and Dispute Resolution)</ListItem>
        <ListItem>Clause 17 (General Provisions)</ListItem>
        <ListItem>
          Any other clauses that should reasonably survive by nature.
        </ListItem>
      </List>
      <Paragraph>
        <h6>17.8 Headers:</h6> All headers and sub-headers in these T&Cs are
        provided for convenience only and have no legal or interpretative effect
        on the construction of these T&Cs.
      </Paragraph>

      <SubTitle>18. APP NOTIFICATION</SubTitle>
      <Paragraph>
        By accessing or using the App or Services, you agree to receive
        notifications from us, including updates, alerts, promotional messages,
        and other communications via the App or email (“App Notifications”). To
        the fullest extent permitted by law, you agree that App Notifications
        are as legally valid and enforceable as written notices, from the time
        you receive them or the time you would have received them had you
        enabled such notifications through your App, email, and/or device
        settings. You can manage your notification preferences in your account
        settings, but you acknowledge that certain notifications, such as those
        related to security updates or essential changes to the App or our
        Services (e.g., changes to the T&Cs or Privacy Policy), will not be
        disabled. You agree to check your notifications regularly to ensure you
        don't miss any important ones.
      </Paragraph>

      <SubTitle>19. CONTACTS AND SUPPORT</SubTitle>
      <Paragraph>
        For any suggestions, questions, concerns, or issues related to the App,
        Services, T&Cs, or Privacy Policy, you may contact our support team
        through the contact information provided within the App under the
        “Contact” tab. We may update our contact information from time to time,
        and you are responsible for ensuring you have access to the most current
        contact details. You agree to provide accurate and complete information
        when seeking support to ensure efficient assistance. Our support team
        will make reasonable efforts to respond to your inquiries, but we do not
        guarantee that all issues will be resolved to your satisfaction.
      </Paragraph>
      <CopyRight>Rize Terms & Conditions – EF LEGAL 02 12 2024 BA</CopyRight>
    </Container>
  );
};

export default TermsAndConditions;